module.exports = __webpack_public_path__ + "img/search-outline.20d70e5f.svg";